
import { BcLineModel } from '../bc/bc-line.model';
import { SocieteLinkedModel } from '../societe-linked.model';
import { BpModel } from './bp.model';
import { LivraisonBcService } from 'src/app/shared/services/bc/livraison-bc.service';
import { LivraisonBcModel } from '../bc/livraison-bc.model';

export class BpLineModel extends SocieteLinkedModel {
    // id BP
    code: string = '*';
    idBp: number;
    bp: BpModel;
    // id BC ligne
    idBcLigne?: number;
    bcLigne: BcLineModel;
    // Désignation
    designation: string;
    // codeLib Article
    codeArticle: string;
    libelleArticle: string;
    // QTE (obligatoire)
    qte: number;
    // prix unitaire
    pu: number;
    // Montant HT
    ht: number;
    // Montant TTC
    ttc: number;
    // codeLib TVA
    codeTva: string;
    libelleTva: string;
    // taux TVA
    tauxTva: number;
    // codeLib NA
    codeNa: string;
    libelleNa: string;
    // codeLib CG Charge
    codeCgCharge: string;
    libelleCgCharge: string;
    // codeLib CA1
    codeCa1: string;
    libelleCa1: string;
    // codeLib CA2
    codeCa2: string;
    libelleCa2: string;
    // codeLib Complement
    codeComp: string;
    libelleComp: string;
    // Equipement | N° de parc
    vehicule: string;
    // code Chantier ( ancien code ae)
    chantier: string;
    // Dates
    dAnnule: Date;
    dModification: Date;
    dCreation: Date;
    dDprovis: Date;
    // Statuts
    bFacture: boolean;
    bAnnule: boolean;

    position: number;

    idLivraison?: number;



    constructor(bcLine?: BcLineModel, liv?: LivraisonBcModel) {
        super();
        if (bcLine) {
            this.id = 0;
            this.idBp = 0;
            this.position = 0;
            this.libelle = bcLine.libelle;
            this.idBcLigne = bcLine.id;

            this.codeCa1 = bcLine.codeCa1;
            this.libelleCa1 = bcLine.libelleCa1;

            this.codeCa2 = bcLine.codeCa2;
            this.libelleCa2 = bcLine.libelleCa2;

            this.codeArticle = bcLine.codeArticle;
            this.libelleArticle = bcLine.libelleArticle;

            this.codeTva = bcLine.codeTva;
            this.libelleTva = bcLine.libelleTva;

            this.tauxTva = bcLine.tauxTva;

            this.codeCgCharge = bcLine.codeCgCharge;
            this.libelleCgCharge = bcLine.libelleCgCharge;

            this.codeNa = bcLine.codeNa;
            this.libelleNa = bcLine.libelleNa;

            this.codeComp = bcLine.codeComp;
            this.libelleComp = bcLine.libelleComp;

            this.vehicule = bcLine.vehicule;
            this.chantier = bcLine.chantier;
            this.ttc = bcLine.ttc;
            this.qte = liv.qteLivre;
            this.ht = bcLine.ht;
            this.pu = bcLine.pu;
            this.bFacture = false;
            this.bAnnule = false;
            this.idSociete = bcLine.idSociete;
            this.bcLigne = bcLine;
            this.societe = bcLine.societe;
            this.idLivraison = liv.id;
        }
    }
}
